//library
import { useState } from "react";

//code
import { API } from "../../services";

/**
 * Get the list of applications from the database
 * @returns {object} - The applications data
 *
 */
const useListApplication = () => {
	const [applications, setApplications] = useState([]);
	const [count, setCount] = useState(0);
	const [monthlyApplications, setMonthlyApplications] = useState(0);
	const [yearlyApplications, setYearlyApplications] = useState(0);

	const [loading, setLoading] = useState(true);

	const [searchTerm, setSearchTerm] = useState("");
	const [searchStartDate, setSearchStartDate] = useState(null);
	const [searchEndDate, setSearchEndDate] = useState(null);
	/**
	 * Retrieve applications
	 */
	const loadApplications = async () => {
		const applications = await API.Application.get_applications();
		setApplications(applications.applications);
		setCount(applications.count);

		const analytics = await API.Application.get_analytics();
		setMonthlyApplications(analytics.monthlyTransactions);
		setYearlyApplications(analytics.yearlyTransactions);

		setLoading(false);
	};
	/**
	 * Search applications
	 * @param {object} search - The search query
	 * @param {object} date - The date query, if present
	 */
	const searchApplications = async (limit = 10, offset = 0, search, date) => {
		const applications = await API.Application.search_applications({
			limit,
			offset,
			search,
			date,
		});
		setApplications(applications.applications);
		setLoading(false);
	};

	/**
	 * Callback function when text inputs are changed
	 *
	 * @param {string} type - corresponding input type that is to be updated
	 */
	const handleSearch = (event) => {
		setSearchTerm(event.target.value);

		if (searchEndDate !== null) {
			searchApplications(
				undefined,
				undefined,
				event.target.value,
				searchStartDate.unix() + "," + searchEndDate.unix()
			);
		} else {
			searchApplications(undefined, undefined, event.target.value);
		}
	};

	return {
		loadApplications,
		searchApplications,
		applications,
		setApplications,
		count,
		setCount,
		monthlyApplications,
		setMonthlyApplications,
		yearlyApplications,
		setYearlyApplications,
		loading,
		setLoading,
		handleSearch,
		searchTerm,
		searchStartDate,
		setSearchStartDate,
		searchEndDate,
		setSearchEndDate,
	};
};

export default useListApplication;
